export default {
  namespaced: true,
  state: {
    autoChangeEndDate: false,
    payload: {
      selectedPeriod: 'consumptionperiod',
      start_date: '',
      end_date: '',
      measures: [],
      rows_per_page: 10,
      page_nr: 1,
      sort_by: '',
      sort_direction: 'ASC',
      reachCriteria: 15,
      columns: [],
      title_search: '',
      site_id: [],
      title_codes: [],
    },
  },
  getters: {
    reachApiBody: state => state.payload,
    title_codes: state => state.payload.title_codes,
  },
  mutations: {
    updatePeriod(state, newSelectedPeriod) {
      state.payload.selectedPeriod = newSelectedPeriod;
    },
    updateMeasures(state, newMeasures) {
      state.payload.measures = newMeasures;
    },
    updateTitleCodes(state, newTitleCodes) {
      state.payload.title_codes = newTitleCodes;
    },
    emptyTitleCodes(state) {
      state.payload.title_codes = [];
    },
    updateStartDate(state, newStartDate) {
      state.payload.start_date = newStartDate;
    },
    updateEndDate(state, newEndDate) {
      state.payload.end_date = newEndDate;
    },
    updateMeasureType(state, newMeasureType) {
      state.payload.measures.forEach(measure => {
        measure.measure_type = newMeasureType;
      });
    },
    updateMinViewingTime(state, newMinViewingTime) {
      state.payload.reachCriteria = newMinViewingTime;
      state.payload.measures.forEach(measure => {
        measure.min_viewing_time = newMinViewingTime;
      });
    },
    updateAutoChangeEndDate(state, newAutoChangeEndDate) {
      state.autoChangeEndDate = newAutoChangeEndDate;
    },
  },
};
